module.exports = __webpack_public_path__ + "img/icon_ccgl.77b15b13.png";